import CountrySimpleForm from './CountrySimpleForm'
export default CountrySimpleForm
